import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { ConsultarDocumentosResponse } from '../../models/cotizador-contratante/consultarDocumentos/response/consultar-documentos-response.model';
import { ConsultarDocumentosRequest } from '../../models/cotizador-contratante/consultarDocumentos/request/consultar-documentos-request.model';
import { URL_MAP } from '../../shared/urlMap';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConsultarDocumentosService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.DOCUMENTOS_TIPOS_DOCUMENTOS}`;

  constructor(private httpClient: HttpClient) { }

  consultarDocumentos(): Observable<ConsultarDocumentosResponse> {
    const request: ConsultarDocumentosRequest = {
      nombreClave: 'getSpDocuTipos',
      jsonParametros: '{}'
    };

    return this.httpClient.post<ConsultarDocumentosResponse>(this.apiUrl, request).pipe(
      catchError(error => {
        console.error('Error en consultarDocumentos: ', error);
        return throwError(() => new Error(error?.message || 'Error al consultar tipos de documento'));
      })
    );
  }
}
